import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LetDirective, PushPipe } from '@ngrx/component';

import {
  TerraAvatarModule,
  TerraCheckboxModule,
  TerraDividerModule,
  TerraIconModule,
  TerraNumberInputModule,
} from '@ninety/terra';
import { NinetyTooltipDirective, DisplayNameOrEmailPipe, AlertComponent, ButtonComponent } from '@ninety/ui/core';
import { IssuesMetricsComponent } from '@ninety/web/pages/issues-v2/components/issues-metrics/issues-metrics.component';

import { MeetingCardComponent } from './meeting-card/meeting-card.component';
// eslint-disable-next-line max-len
import { MeetingDetailHeadlinesComponent } from './meeting-card/meeting-detail-rocks-todos-issues-headlines/meeting-detail-headlines/meeting-detail-headlines.component';
// eslint-disable-next-line max-len
import { MeetingDetailRocksTodosIssuesHeadlinesComponent } from './meeting-card/meeting-detail-rocks-todos-issues-headlines/meeting-detail-rocks-todos-issues-headlines.component';

@NgModule({
  exports: [MeetingCardComponent],
  imports: [
    MatFormFieldModule,
    CommonModule,
    TerraDividerModule,
    AlertComponent,
    MeetingDetailHeadlinesComponent,
    MatToolbarModule,
    MatListModule,
    MatTooltipModule,
    MatButtonModule,
    MatCardModule,
    TerraIconModule,
    MatMenuModule,
    MatDividerModule,
    LetDirective,
    PushPipe,
    IssuesMetricsComponent,
    TerraCheckboxModule,
    TerraAvatarModule,
    TerraNumberInputModule,
    ButtonComponent,
    NinetyTooltipDirective,
    DisplayNameOrEmailPipe,
    MeetingCardComponent,
    MeetingDetailRocksTodosIssuesHeadlinesComponent,
  ],
})
export class MeetingSharedModule {}
